import { DocumentVerificationService } from "./document-verification/document-verification.service"
import { NotificationEngineService } from "./notification-engine/notification-engine.service"
import { OcrService } from "./OCR/ocr.service"

export const PROVIDERS = [
    DocumentVerificationService,
    NotificationEngineService,
    OcrService];
    